import { render, staticRenderFns } from "./manage-price-list.vue?vue&type=template&id=3301d71a"
import script from "./manage-price-list.vue?vue&type=script&lang=js"
export * from "./manage-price-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports